// Mirrors proposalsClusterArgsSchema in packages/middleware/src/cpg/proposals-cluster.runner.ts
// — keep the shape and default in sync: { minPatients: number (default 5), familyGroup? }
// where familyGroup is a family group slug; absent = every group.
export const DEFAULT_MIN_PATIENTS = 5

function field(value: unknown, key: string): unknown {
  return typeof value === 'object' && value !== null && key in value
    ? (value as Record<string, unknown>)[key]
    : undefined
}

export function extractMinPatients(value: unknown): unknown {
  return field(value, 'minPatients')
}

export function extractFamilyGroup(value: unknown): unknown {
  return field(value, 'familyGroup')
}

/** An empty family group means every group. */
export function buildProposalsClusterArgs(minPatients: number | string, familyGroup: string) {
  const trimmed = familyGroup.trim()
  return { minPatients, ...(trimmed ? { familyGroup: trimmed } : {}) }
}

export function validateProposalsClusterArgs(value: unknown): string | null {
  if (value === undefined || value === null) return null
  if (typeof value !== 'object' || Array.isArray(value)) return 'Args must be an object'
  const minPatients = extractMinPatients(value)
  if (
    minPatients !== undefined &&
    (!Number.isInteger(minPatients) || (minPatients as number) < 1)
  ) {
    return 'Minimum patients must be a whole number of at least 1'
  }
  const familyGroup = extractFamilyGroup(value)
  if (familyGroup !== undefined && (typeof familyGroup !== 'string' || familyGroup.trim() === '')) {
    return 'Family group must be a group slug, or left empty for every group'
  }
  return null
}
